import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {EviScrollToTop} from '../Common/EviScrollToTop';

function getDescriptionTerms(product) {
  const description = _.get(product, 'paymentOptions.paymentDescription', '-');
  const terms = _.get(product, 'paymentOptions.terms', '-');

  return { description, terms };
}

class RexThanks extends Component {
  static propTypes = {
    user: PropTypes.object,
    productDetails: PropTypes.array,
    delivery: PropTypes.string
  };

  render() {
    const { user, productDetails, delivery } = this.props;

    return (
      <div className="ea-snapper-fluid-container">
        <EviScrollToTop/>
        <div className="ea-fgrid ea-fgrid--gutter" style={{ padding: '3em', maxWidth: '1100px', margin: '0 auto 0 auto' }}>
          <div className="ea-fgrid__item">
            <div className="ea-color-container ea-color-container--stretch">
              <h1 className="ea-h1">Mukavaa, että haluat jatkaa kanssamme!</h1>
              <h3 className="ea-h3">Olemme lähettäneet tilausvahvistuksen osoitteeseen {delivery}</h3>
            </div>
          </div>
          <div className="ea-fgrid__item">
            <div className="ea-color-container ea-color-container--stretch" style={{ paddingTop: '2em' }}>
              <div style={{ float: 'left', paddingRight: '2em' }}><img src="/img/rex/download.png"/></div>
              <div style={{ float: 'left', paddingTop: '0.5em' }}>
                <h4 className="ea-h4">Lataa itsellesi Elisa Viihde -sovellus</h4>
                <p>Tiesithän, että mobiilisovellus sisältyy palvelun hintaan kaikkiin perheesi laitteisiin.</p>
                <div>
                  <div style={{ float: 'left', paddingRight: '2em' }}><img src="/img/rex/apple.png" style={{ verticalAlign: 'middle' }}/><a href="https://itunes.apple.com/fi/app/elisa-viihde-suomen-suosituin/id488047195">Apple</a></div>
                  <div style={{ float: 'left' }}><img src="/img/rex/android.png" style={{ verticalAlign: 'middle' }}/><a href="https://play.google.com/store/apps/details?id=com.elisa.viihde">Android</a></div>
                </div>
              </div>
            </div>
          </div>

          <div className="ea-fgrid__item" style={{ paddingTop: '3em' }}>
            <h3 className="ea-h3">Tilaajan tiedot</h3>
          </div>

          <div className="ea-fgrid__item" style={{ marginTop: 0 }}>
            <div className="ea-fgrid">
              <div className="ea-fgrid__item ea-fgrid__item--phone-2 ea-fgrid__item--tablet-4">
                <div className="ea-color-container">
                  {user.firstName} {user.lastName}<br/>
                  {user.email}
                </div>
              </div>
              <div className="ea-fgrid__item ea-fgrid__item--phone-2 ea-fgrid__item--tablet-4">
                <div className="ea-color-container">
                  {user.address.street}<br/>
                  {user.address.zipCode} {user.address.city}<br/>
                </div>
              </div>
              { user.customerId &&
                <div className="ea-fgrid__item ea-fgrid__item--phone-2 ea-fgrid__item--tablet-4">
                  <div className="ea-color-container">
                    Asiakasnumero: {user.customerId}
                  </div>
                </div>
              }
            </div>
          </div>

          <div className="ea-fgrid__item" style={{ paddingTop: '3em' }}>
            <h3 className="ea-h3">Yhteenveto</h3>
          </div>

          { productDetails.map((product, idx) => {
            const { description, terms } = getDescriptionTerms(product);
            return (
              <div className="ea-fgrid__item" key={idx}>
                <div className="ea-fgrid">
                  <div className="ea-fgrid__item ea-fgrid__item--phone-2 ea-fgrid__item--tablet-4">
                    <div className="ea-color-container"><b>{product.productName}</b></div>
                  </div>
                  <div className="ea-fgrid__item ea-fgrid__item--phone-2 ea-fgrid__item--tablet-4">
                    <div className="ea-color-container">{description}</div>
                  </div>
                  <div className="ea-fgrid__item ea-fgrid__item--phone-2 ea-fgrid__item--tablet-4">
                    <div className="ea-color-container">{terms}</div>
                  </div>
                </div>
              </div>);
          })
          }

        </div>
      </div>
    );
  }
}

export default RexThanks;



// WEBPACK FOOTER //
// ./web/js/components/rex/Thanks.js